<div>
  <div class="modal-header">
    <h3>Existing application found</h3>
  </div>
  <div class="modal-body">
    Would you like to continue your existing application or start a new one.
    <div class="row" style="justify-content: space-around">
      <div class="col-xs-12 col-sm-3 col-sm-offset-3 text-center" style="padding-bottom: 10px;">
        <button class="btn btn-default" (click)="close(true)">Resume Application</button>
      </div>
      <div class="col-xs-12 col-sm-3 col-sm-offset-3 text-center" style="padding-bottom: 10px;">
        <button class="btn btn-default" (click)="close(false)">Start New Application</button>
      </div>
    </div>

  </div>
  <div class="modal-footer">
  </div>
</div>
